'use strict';
angular.module('appMarketplace')
    .service('AppInsightsConfigService', ['$http', 'UrlService', function ($http, UrlService) {
        var service = this;

        service.getAppInsightsConfig = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/app-insights')
            };

            return $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data);
            });
        };

        service.saveAppInsightsProperty = function (appInsightsProperty, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/app-insights'),
                data: {
                        "key": appInsightsProperty.key,
                        "value": appInsightsProperty.value,
                        "description": appInsightsProperty.description
                }
            };

            return $http(req).then(function successCallbackWrapper(response) {
                successCallback(appInsightsProperty);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data);
            });
        };

        service.deleteAppInsightsProperty = function (key, successCallback, errorCallback) {
            var req = {
                method: 'DELETE',
                url: UrlService.createAbsoluteUrl('/rest/app-insights/' + key)
            };

            $http(req).then(function (response) {
                successCallback();
            }, function () {
                errorCallback();
            })
        };
    }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/services/app-insights-config-service.js
// module id = 69
// module chunks = 10 17